<template>
  <div style="height: 100%;">
    <table>
      <!-- 设置列宽 -->
      <colgroup>
        <col width="20%">
        <col width="20%">
        <col />
      </colgroup>
      <thead>
        <th>医院名称</th>
        <th>医院编码</th>
        <th>影像量</th>
        <th>服务数</th>
        <th>存储量</th>
      </thead>
    </table>
    <vue-seamless-scroll :data="dataList" :class-option="optionHover" class="seamless-warp" v-if="dataList[0]">
      <ul>
        <li v-for="item in dataList" class="liStyle">
          <span class="title1 text_align">{{ item.organName }}</span>
          <span class="title2 text_align">{{ item.organCode }}</span>
          <span class="title2 text_align">{{ item.imageCount }}</span>
          <span class="title2 text_align">{{ item.serviceCount }}</span>
          <span class="title2 text_align">{{ item.amountOfStorage }}</span>
        </li>
      </ul>
    </vue-seamless-scroll>
  </div>
</template>

<script>
export default {
  props:{
    dataList:{
      type:Array,
      required:true,
    }
  },
  name: '',
  components: {

  },
  data() {
    return {
   
    }
  },
  computed: {
    //滚动表格的配置项
    optionHover() {
      return {
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        step: 0.2,// 数值越大速度滚动越快
        openWatch: true, // 开启数据实时监控刷新dom
        // limitMoveNum: 5, //开始滚动的数据量
        // singleHeight: 0, //单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        // singleWidth: 0, //单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        // waitTime: 1000 //单步运动停止的时间(默认值1000ms)
      }
    }
  },

  created() {
    console.log('----',this.dataList);
  },
  methods: {

  },
}
</script>

<style lang="scss" scoped>
  * {
  margin: 0;
  padding: 0;
  /*font-weight: normal;*/
}

ul {
  list-style: none;
    li{
      
      border-bottom: 1px solid #E5E5E5;
      color: #333;
      font-size: 14px;
      // span{
      // }
    }
}

table {
      // height: 80%;
      width: 100%;
      text-align: center;
}

th {
	height: 40px;
	line-height: 40px;
	font-size: 16px;
  color: #666666;
  font-weight: normal;
	// background-color: rgba(180, 181, 198, 0.1);
}

.seamless-warp {
	height: 74%;
	overflow: hidden;
		.liStyle {
		height:40px;
			line-height: 40px;
			width: 100%;
			display: flex; //设置flex布局，否则span标签无法设置宽度
			  //设置宽度与表头列宽一致
			  .title1 { width: 20%; }
				
			  .title2 { width: 20%; }
			  // 
			  .text_align { text-align: center; }
		}
}
</style>